import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=616efd6d&scoped=true"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616efd6d",
  null
  
)

export default component.exports